var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-message-container"},[_c('h1',[_vm._v("马拉松照片广告覆盖精目标用户")]),_vm._v(" "),_c('span',[_vm._v("借助马拉松赛事影响力，整合马拉松赛事所有资源，帮助企业挖掘商机，获得销售业绩的增长。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113f6cb9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantage/components/TextMessageBanner.vue
// module id = null
// module chunks = 